@let currentLabel = label();
@let currentOptions = options();
@let currentLayout = layout();

<div [class.mb-4]="mb()">
  @if (currentLabel) {
    <label class="block text-[12px] font-bold mb-1">{{ currentLabel }}</label>
  }

  <div
    class="flex"
    [class.flex-col]="currentLayout === 'vertical'"
    [class.space-y-2]="currentLayout === 'vertical'"
    [class.flex-row]="currentLayout === 'horizontal'"
    [class.space-x-4]="currentLayout === 'horizontal'"
    [class.flex-wrap]="currentLayout === 'horizontal'"
    [class.items-center]="currentLayout === 'horizontal'"
  >
    @for (option of currentOptions; track option.value; let i = $index) {
      <div class="flex items-center py-2">
        <input
          type="checkbox"
          [id]="getCheckboxId(option.value, i)"
          [value]="option.value"
          [checked]="isSelected(option.value)"
          [disabled]="isDisabled"
          (change)="toggleSelection(option.value)"
          (blur)="onTouched()"
          class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
        />
        <label
          [for]="getCheckboxId(option.value, i)"
          class="ml-2 block text-[14px] text-gray-900 cursor-pointer"
        >
          {{ option.display }}
        </label>
      </div>
    }
  </div>
  <lib-custom-error-display [errors]="errors()" [control]="ngControl"></lib-custom-error-display>
</div>
